import {isEmpty, isNil, notEmpty} from '@megaphonenpm/mputils/src/utils.js';
import {ScreenComponent} from "./ScreenComponent.js";
import {fitText, setText} from '@megaphonenpm/mputils/src/DOM.js';
import {cloneInstance} from "../GWDService.js";
import {play} from '../Animation.js';
import {MegaScreen} from '../MegaScreen.js';
import {sum} from 'lodash-es';
import {NumberAnimator} from '@megaphonenpm/mputils/src/NumberAnimator.js';
import {CHANGE} from '@megaphonenpm/mputils/src/constants.js';

/**
 * Displays the total number of votes that have been received for the current scene.
 * The main view for the TotalVotesComponent is a GWD element named "#totalVotes" that
 * the RunView clones into the overlays layer.
 *
 * TODO: Set total_votes_label_txt's textContent to theme locale setting, and then use fitText() to
 *       auto-size the font.
 */
export class TotalVotesComponent extends ScreenComponent {
  constructor (themeID) {
    super(themeID, ['totalVotes']);

    // Animates the on-screen "total votes" number.
    this.numberAnimator = new NumberAnimator();
    this.numberAnimator.on(CHANGE, this.totalvotesAnimatorChangeListener.bind(this));
  }

  build () {
    super.build();

    // Pre-flight check
    if (!this.valid) {
      return;
    }

    // Start build
    this.view = cloneInstance(this.themeID, 'totalVotes');

    this.total_votes_txt = this.view.querySelector('#total_votes_txt');

    // Assign "Total Votes" label's text, if any was specified in the theme's settings
    let totalVotesLocaleString = this.getLocaleString('total_votes');

    if (notEmpty(totalVotesLocaleString)) {
      let totalVotesLabel = this.view.querySelector('.total_votes_label_txt');
      setText([totalVotesLabel], totalVotesLocaleString);
      setTimeout(() => {
        totalVotesLabel.style.removeProperty('font-size');
        fitText(totalVotesLabel, totalVotesLabel.clientWidth, totalVotesLabel.clientHeight);
      }, 0);
    }
  }

  totalvotesAnimatorChangeListener () {
    this.render();
  }

  /**
   * Updates the number of votes in the total_votes_txt element. If numVotes is specified, uses the
   * supplied value. If numVotes is not specified, uses the actual number of votes for the scene
   * (as reported to MegaScreen by MRTS).
   *
   * @param numVotes
   */
  updateVotes (numVotes) {
    if (!this.valid) {
      return;
    }

    if (isEmpty(numVotes)) {
      if (MegaScreen.globals.appState.votes.length > 0) {
        numVotes = sum(MegaScreen.globals.appState.votes);
      } else {
        numVotes = 0;
      }
    }

    if (numVotes === 0) {
      // Never animate down to 0
      this.numberAnimator.skipTo([0]);
    } else {
      // Note that if numVotes, numberAnimator will ignore this assignment, so redundant calls to
      // animateTo() are harmless.
      this.numberAnimator.animateTo([numVotes]);
    }
  }

  render () {
    let currentAnimatingVotesValue = this.numberAnimator.current[0];
    currentAnimatingVotesValue = isNil(currentAnimatingVotesValue) ? '' : currentAnimatingVotesValue;

    // Don't render the new total votes unless it has changed
    if (currentAnimatingVotesValue.toString() !== this.total_votes_txt.textContent) {
      setText([this.total_votes_txt], currentAnimatingVotesValue.toString());

      setTimeout(() => {
        this.total_votes_txt.style.removeProperty('font-size');
        fitText(this.total_votes_txt, this.total_votes_txt.parentNode.clientWidth, this.total_votes_txt.parentNode.clientHeight);
      }, 0);
    }
  }

  playIntro () {
    play(this.view, 'start');
  }

  resetVotes () {
    this.updateVotes(0);
  }

  reset () {
    this.resetVotes();
  }
}
